<div class="screen screen--subpage">

  <header class="subpage__hero ga-photo ga-photo--lavender">
    <div class="subpage__hero-scrim"></div>
    <button class="detail__round" type="button" data-id="back" aria-label="<%= _lcs( 'Zurück' ) %>"><i class="icon icon--arrow-left"></i></button>
    <div class="subpage__hero-title">
      <p class="belturo-eyebrow subpage__eyebrow"><%= house %></p>
      <h1 class="subpage__heading"><%= _lcs( 'Spa & Wellness' ) %></h1>
    </div>
  </header>

  <div class="subpage__body">
    <div class="tiles">
      <div class="tile tile--green">
        <div class="tile__label"><%= _lcs( 'Sauna & Pool' ) %></div>
        <div class="tile__value"><%= _lcs( '10 – 21 Uhr' ) %></div>
      </div>
      <div class="tile tile--sand">
        <div class="tile__label"><%= _lcs( 'Für Hausgäste' ) %></div>
        <div class="tile__value"><%= _lcs( 'frei nutzbar' ) %></div>
      </div>
    </div>

    <h3 class="subpage__subhead"><%= _lcs( 'Behandlungen' ) %></h3>
    <div class="treatlist">
      <% treatments.forEach( function( t ) { %>
        <div class="treat">
          <span class="treat__icon"><i class="icon icon--<%= t.icon %>"></i></span>
          <span class="treat__text">
            <span class="treat__title"><%= t.title %></span>
            <span class="treat__dur"><%= t.dur %></span>
          </span>
          <span class="badge badge--accent badge--sm"><%= t.price %></span>
        </div>
      <% } ); %>
    </div>

    <button class="btn btn--primary btn--lg btn--block" type="button" data-id="book">
      <i class="icon icon--calendar-check"></i> <%= _lcs( 'Termin anfragen' ) %>
    </button>
  </div>

</div>
